import { Card } from '../../components/core/Card.jsx'
import { AdminLayout, Table } from '../../admin/AdminLayout.jsx'

// The free checks: how many, and the latest. A published figure from these
// uses only checks run on or after 12 October 2026, the privacy policy's date.
export default function AdminFreeChecks({ total = 0, last_30_days = 0, by_status = {}, checks = [] }) {
  const statuses = Object.entries(by_status).map(([s, n]) => `${n} ${s}`).join(' · ')
  const rows = checks.map((c) => ({
    ...c,
    industry_cell: c.typed ? `${c.industry} (typed)` : c.industry,
    claimed_cell: c.claimed ? 'Signed up' : '',
  }))

  return (
    <AdminLayout title="Free checks">
      <Card pad="md" title={`${total} in all, ${last_30_days} in the last 30 days`} description={statuses || 'None yet.'}>
        <Table
          columns={[
            ['checked', 'Checked'], ['company', 'Company'], ['email', 'Address'], ['place', 'Market'],
            ['industry_cell', 'Industry'], ['status', 'Status'], ['claimed_cell', ''],
          ]}
          rows={rows}
          empty="No free checks yet."
        />
      </Card>
    </AdminLayout>
  )
}
